import TransactionTermsForm from './TransactionTermsForm';

export default TransactionTermsForm;
